export default __webpack_public_path__ + "static/media/5.486ccf61.svg";